<script lang="ts">
export default { name: "GalleryContainerBanner" };
</script>

<script setup lang="ts">
import * as vue from "vue";
import type { GalleryBanner } from "@/models/gallery";

defineProps({
	banner: {
		type: Object as vue.PropType<GalleryBanner>,
		required: true
	}
});

const isFillScreen = vue.ref(false);

const bannerRef = vue.ref<HTMLElement>();

vue.onMounted(() => {
	const observer = new IntersectionObserver(
		([entry]) => {
			isFillScreen.value = entry.isIntersecting;
		},
		{ threshold: 0.65 }
	);

	if (bannerRef.value) {
		observer.observe(bannerRef.value);
	}

	vue.onBeforeUnmount(() => observer.disconnect());
});
</script>

<template>
	<div
		:id="banner.id"
		class="banner"
		v-bind:class="{ 'banner-fill-screen': isFillScreen }"
		ref="bannerRef"
	>
		<div v-if="isFillScreen" class="banner_title-container">
			<span class="banner_title-container_subtitle">{{ banner.subtitle }}</span>
			<span class="banner_title-container_title">{{ banner.title }}</span>
		</div>
		<img :src="banner.url" :alt="banner.description" />
	</div>
</template>

<style scoped lang="scss">
.banner {
	width: 80vw;
	position: relative;
	transition:
		width 0.5s ease-in-out,
		height 0.5s ease-in-out;

	img {
		width: 100%;
		height: auto;
	}
}

.banner-fill-screen {
	width: 100vw;
	height: auto;
	img {
		box-shadow: 0 0.3em 2em rgba(0, 0, 0, 0.25);
		width: 100%;
		height: 100%;
	}
}

.banner_title-container {
	color: white;
	display: flex;
	flex-direction: column;
	font-family: Sarabun, sans-serif;
	left: clamp(1rem, 4vw, 5rem);
	position: absolute;
	text-align: left;
	text-transform: uppercase;
	bottom: calc(20%);
}

.banner_title-container_subtitle {
	font-size: clamp(0.875rem, 2.5vw, 1.5rem);
}

.banner_title-container_title {
	font-size: clamp(1.5rem, 5vw, 5rem);
	font-weight: bold;
}
</style>
